import { render, staticRenderFns } from "./addCostType.vue?vue&type=template&id=3ebbcb8c&scoped=true&"
import script from "./addCostType.vue?vue&type=script&lang=js&"
export * from "./addCostType.vue?vue&type=script&lang=js&"
import style0 from "./addCostType.vue?vue&type=style&index=0&id=3ebbcb8c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebbcb8c",
  null
  
)

export default component.exports